<template>
    <v-layout>
        <v-flex class="group-admin-config">
            <div class="group-admin-config__request" v-if="getConfigureGroup">
                <h6>{{groupConstants.GROUP_CONFIGURATION}}</h6>
            </div>
            <v-flex class="inner-scrollbar pending-requests__body" v-if="!showRequests && !getConfigureGroup">
                <v-flex text-xs-center pt-2>{{networkConstants.NO_PENDING_REQUESTS}}</v-flex>
            </v-flex>
            <v-flex>
                <configure-group :isNewGroupRequest="$attrs.isNewGroupRequest" class="group-admin-config__form"></configure-group>
            </v-flex>
        </v-flex>
    </v-layout>
</template>

<script>
    import { groupConstants } from "../GroupPage/groupConstant";
    import ConfigureGroup from "../GroupPage/ConfigureGroup";
    import { mapActions, mapGetters } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { networkConstants } from "../ChapterPage/communityCommon.constant";

    export default {
        components: {
            ConfigureGroup,
        },
        created() {
            this.getPendingRequestList();
        },
        data() {
            return {
                networkConstants,
                groupConstants,
            };
        },
        methods: {
            ...mapActions({
                getPendingRequestList: `group/${storeAction.getPendingRequestList}`,
            }),
        },
        computed: {
            ...mapGetters({
                pendingRequestList: `group/${storeGetters.pendingRequestList}`,
                getConfigureGroup: `network/${storeGetters.getConfigureGroup}`,
                getRequestedGroups: `network/${storeGetters.getRequestedGroups}`,
            }),
            showRequests() {
                return this.pendingRequestList && this.pendingRequestList.length > 0;
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .group-admin-config {
        background: $white;
        padding: 20px;
        letter-spacing: 0.26px;
        line-height: 20px;

        h3 {
            text-align: center;
            color: $ypo-blue;
            font-family: "Raleway", sans-serif;
            font-size: 22px;
            font-weight: 500;
            line-height: 26px;
            margin-bottom: 30px;
        }

        p {
            margin-bottom: 20px;
        }

        &__request {
            margin: 0 -20px;

            h6 {
                font-size: 16px;
                letter-spacing: 0.3px;
                line-height: 20px;
                font-weight: 400;
                border-bottom: 1px solid $ypo-medium-gray;
                padding: 0 0 25px 20px;
                margin-bottom: 15px;
            }

            p {
                margin: 0 20px;
                border-bottom: 1px solid $ypo-medium-gray;
                padding-bottom: 15px;
            }
        }

        &__form {
            h6 {
                font-weight: 400;
                margin-bottom: 15px;
                color: $ypo-gray-text;
                font-size: 14px;
                letter-spacing: 0.26px;
                line-height: 20px;
                margin-top: 10px;
            }

            p {
                font-size: 14px;
                margin-bottom: 0px;
                padding-left: 30px;
            }

            .v-radio {
                margin-bottom: 15px !important;
                align-items: flex-start;

                .v-icon {
                    font-size: 20px;
                    margin-left: 2px;
                }
            }

            em {
                font-style: normal;
                color: $ypo-cta;
                font-weight: 400;

                i {
                    margin-right: 5px;
                    position: absolute;
                    left: 2px;
                    top: 5px;
                }
            }

            .terms {
                strong {
                    color: $ypo-cta;
                    font-size: 14px;
                    font-weight: 500;
                    letter-spacing: 0.26px;
                    line-height: 20px;
                    display: block;
                    margin-bottom: 10px;
                }

                .v-label {
                    font-size: 14px;
                    color: $ypo-gray-text !important;
                    font-weight: 400;
                }
            }
        }

        .groupRequestRadio {
            color: $ypo-gray-text;
            font-size: 12px;
            font-weight: initial;
        }

        .button-group {
            border-top: 1px solid $ypo-medium-gray;
            margin: 0 -30px -20px -30px;
            padding: 7px 15px 0 0;
            text-align: right;
        }

        .description {
            strong {
                font-weight: 400;
            }

            textarea {
                border: 1px solid $ypo-medium-gray;
                border-radius: 4px;
                height: 60px;
            }

            .error--text {
                textarea {
                    border-color: $ypo-error-red;
                }
            }

            .v-input__slot {
                &:before {
                    display: none;
                }
            }
        }
    }

    .pending-requests {
        &__title {
            display: block;
            padding: 15px;
            border-bottom: 2px solid rgba($ypo_blue, 0.1);
            position: relative;
            color: $ypo_blue;
            margin-bottom: 10px;

            small {
                position: absolute;
                right: 15px;
                font-size: 14px;
            }
        }

        &__list {
            padding: 5px 250px 15px 80px;
            border-bottom: 2px solid rgba($ypo_blue, 0.05);
            position: relative;
            margin: 10px;

            figure {
                width: 50px;
                height: 50px;
                overflow: hidden;
                border-radius: 50%;
                position: absolute;
                left: 15px;
                top: 0;
                bottom: 0;

                img {
                    max-width: 100%;
                }
            }

            strong {
                display: block;
                opacity: 0.6;
                color: $ypo_blue;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }

            small {
                color: $ypo_blue;
                opacity: 0.5;
            }

            .pending-requests__actions {
                position: absolute;
                right: 0;
                top: 0px;
            }
        }

        &__body {
            max-height: 500px;
            overflow-y: auto;
            margin-bottom: 20px;

            em {
                font-style: normal;

                font-size: 12px;
                font-weight: 600;
                position: relative;
                top: 10px;
                right: 10px;

                &.success__text {
                    color: $ypo-green;
                }

                &.failure__text {
                    color: $ypo-red;
                }
            }
        }
    }
</style>
